<template>
  <div class="md-layout text-center">
    <div
      class="
        md-layout-item
        md-size-33
        md-medium-size-50
        md-small-size-70
        md-xsmall-size-100
      "
    >
      <login-card :header-color="error ? 'danger' : 'brand'">
        <div slot="title">
          <h4 class="title">WebToPrint</h4>
          <p class="title">{{ error ? errorMessage : '' }}</p>
        </div>
        <p slot="description" class="description">Dobrodošli</p>
        <md-field class="md-form-group" slot="inputs">
          <md-icon>email</md-icon>
          <label>Email...</label>
          <md-input v-model="email" type="email" name="email"></md-input>
        </md-field>
        <md-field class="md-form-group" slot="inputs">
          <md-icon>lock_outline</md-icon>
          <label>Password...</label>
          <md-input
            v-model="password"
            type="password"
            name="password"
          ></md-input>
        </md-field>
        <md-button
          slot="footer"
          class="md-simple md-primary md-lg"
          @click="login"
        >
          <md-icon>login</md-icon>
          Uloguj se
        </md-button>
      </login-card>
    </div>
  </div>
</template>
<script>
import { LoginCard } from '@/components';
import api from '../../../api/api.js';
import services from '@/api/services';
export default {
  components: {
    LoginCard,
  },
  data() {
    return {
      email: null,
      password: null,
      error: false,
      errorMessage: null,
    };
  },
  methods: {
    login() {
      api
        .post(services.users.login, {
          'login-submit': true,
          email: this.email,
          password: this.password,
        })
        .then((data) => {
          if (data.error) {
            this.error = true;
            this.errorMessage = data.message;
          } else {
            this.$router.push({
              path: 'files',
              query: { filter: 'confirmed' },
            });
          }
        });
    },
  },
};
</script>
